import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { CardPreviewService, IWeblinkIcons, iconsWeblink, IBrandcardResult } from '@app/components/card-preview'

@Component({
  selector: 'app-frame-profile',
  templateUrl: './frame-profile.component.html',
  styleUrls: ['./frame-profile.component.scss']
})
export class FrameProfileComponent implements OnInit, AfterViewInit {
  @Input() mediaData: IBrandcardResult
  @Output() goBackToMainIcons = new EventEmitter<boolean>(false)
  @ViewChild('wrapperElement', {static: true}) wrapperElement: ElementRef
  @ViewChild('headerElement', {static: true}) headerElement: ElementRef

  weblinkIcons: IWeblinkIcons = iconsWeblink
  wrapperHeight: number
  headerHeight: number
  contentHeight: number

  constructor(
    private cardPreviewService: CardPreviewService
  ) { }

  ngAfterViewInit() {
    this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
    this.headerHeight = this.headerElement.nativeElement.offsetHeight
    this.contentHeight = this.wrapperHeight - this.headerHeight
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
    this.headerHeight = this.headerElement.nativeElement.offsetHeight
    this.contentHeight = this.wrapperHeight - this.headerHeight
  }

  ngOnInit(): void {}

  goBackToMain() {
    this.goBackToMainIcons.emit(true)
    this.cardPreviewService.setFooterToVisible(false)
    this.cardPreviewService.setScreen2(false)
  }

}
